import React, { memo } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

const optionWizardSvg = (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M24 10V14M24 34V38M14 24H10M38 24H34M16.2 16.2L13.4 13.4M34.6 34.6L31.8 31.8M16.2 31.8L13.4 34.6M34.6 13.4L31.8 16.2"
            stroke="currentColor"
            strokeLinecap="round"
        />
        <circle cx="24" cy="24" r="7" stroke="currentColor" />
        <path d="M24 20V24L26.5 26.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)

const OptionWizard: React.FC<SvgIconProps> = memo((props) => (
    <SvgIcon {...props}>{optionWizardSvg}</SvgIcon>
))

export default OptionWizard
